import { each, filterL, go, head, isNil, not } from "fxjs/es";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleMouseDownOnCanvasEl = (self, event) => {
  const working_layer = self._getWorkingLayerThrowable();
  const selection = self._getSelectionThrowable();
  const selection_translate_transform =
    self._getSelectionTranslateTransformThrowable();
  const rubber_band_layer_el = self._getRubberBandLayerElThrowable();
  const rubber_band = self._getRubberBandThrowable();
  const locking = self._getLockingThrowable();
  const { clientX: client_x, clientY: client_y, target } = event;
  const mouse_down_point = self._toViewPortPoint({
    x: client_x,
    y: client_y,
  });
  self._is_mouse_down = true;
  self._is_mouse_move = false;
  self._mouse_down_position = {
    x: mouse_down_point.x,
    y: mouse_down_point.y,
  };
  self._mouse_move_position = {
    x: mouse_down_point.x,
    y: mouse_down_point.y,
  };
  switch (self._processing_task) {
    case PROCESSING_TASK.PATH_EDITING: {
      if (!(target instanceof self._window.Node)) {
        return;
      }
      const target_node = target;
      each(({ view }) => {
        view.click(target_node);
      })(self._path_editor_list);
      const is_selected = go(
        self._path_editor_list,
        filterL(({ model }) => model.getIsSelected()),
        head,
        isNil,
        not
      );
      if (is_selected) {
        self._processing_task =
          PROCESSING_TASK.PATH_EDITING_TRANSLATE_TRANSFORMING;
      }
      return;
    }
    case null: {
      const is_selectable = working_layer.getIsChildGraphicsEl(target);
      if (
        is_selectable &&
        target instanceof self._window.SVGGraphicsElement &&
        !locking.getIsLocked(target)
      ) {
        selection.setSelectedEls([target]);
        selection_translate_transform.start({
          x: mouse_down_point.x,
          y: mouse_down_point.y,
          els: [...selection.getSelectedEls()],
        });
        self._processing_task = PROCESSING_TASK.TRANSLATE_TRANSFORMING;
      } else {
        selection.setSelectedEls([]);
        const rubber_band_layer_ctm = rubber_band_layer_el.getCTM();
        if (rubber_band_layer_ctm == null) {
          throw new Error(
            `rubber_band_layer 엘리먼트의 CTM 을 구할 수 없습니다.`
          );
        }
        const rubber_band_layer_ctm_inverse = rubber_band_layer_ctm.inverse();
        const point = mouse_down_point.matrixTransform(
          rubber_band_layer_ctm_inverse
        );
        rubber_band.startSelecting({
          x: point.x,
          y: point.y,
        });
        self._processing_task = PROCESSING_TASK.SELECTING;
      }
      return;
    }
    default: {
      return;
    }
  }
};
